<rr-start-logo color="inverse" routerLink="/"></rr-start-logo>
<div class="wrapper">
    <h1>Impressum</h1>
    <h2>Seitenbetreiber</h2>
    <p>
        ideastream GmbH<br />
        Campus Gebäude A1.1,<br />
        66123 Saarbrücken<br />
        Email: contact&#64;ideastream.io<br />
    </p>
    <h2>Datenschutz</h2>
    <p>
        ideastream GmbH<br />
        Campus Gebäude A1.1,<br />
        66123 Saarbrücken<br />
        Email: contact&#64;ideastream.io<br />
    </p>
    <h2>Handelsregister</h2>
    <p>
        Registergericht: Amtsgericht Saarbrücken<br />
        Registernummer: HRB 104703
    </p>
    <h2>Geschäftsführer:</h2>
    <p>Matthias Schmidt</p>
    <h2>Berufshaftpflichtversicherung:</h2>
    <p>
        Bayerischer Versicherungsverband<br />
        Maximilianstraße 53, 80538 München<br />
        Räumlicher Geltungsbereich: Deutschland
    </p>
    <h2>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:</h2>
    <p>DE 458 885 661</p>
    <h2>Inhaltlich Verantwortlicher gemäß § 55 Abs. 2 RStV:</h2>
    <p>
        Matthias Schmidt<br />
        (Anschrift wie oben)
    </p>
    <h2>Urheberrecht und Bildnachweise:</h2>
    <p>
        Die Inhalte von https://ideastream.io sind - soweit nicht abweichend
        angegeben - urheberrechtlich geschützt. Verwendete Fotografien sind ggf.
        mit Bildnachweisen gekennzeichnet oder unten aufgeführt, soweit sie
        nicht selbst angefertigt wurden. Die Verwendung von Fotografien auf
        Drittseiten ist nur im Rahmen der jeweiligen Lizenz der Urheber möglich.
    </p>
</div>
<rr-disclaimer [type]="disclaimerTypes" [showIcon]="false"></rr-disclaimer>
